import { productionReducer as production } from '../production/reducer';
import { supportReducer as support } from '../support/reducer';
import { transportationReducer as transportation } from '../transportation/reducer';
import { accountingReducer as accounting } from './accounting-reducer';
import { communicationReducer as communications } from './communications-reducer';
import { userdataReducer as userdata } from './userdata-reducer';
import { utilityReducer as utility } from './utility-reducer';

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    accounting,
    communications,
    production,
    support,
    transportation,
    utility,
    userdata
};
